const setToken = (token) => { localStorage.setItem('token', token); };
const getToken = () => localStorage.getItem('token');

// const api = 'http://localhost:3000/api'; // localhost
// const api = 'http://192.168.2.227:3000/api'; // local localhost
// const api = 'http://10.241.204.166:3000/api'; // tunnelified
const api = 'https://api.hibilet.com/api'; // production

const headerBuilder = (header, form) => ({
  ...{ header },
  ...(form ? { 'Content-Type': 'application/json' } : null),
  ...(getToken() ? { authorization: getToken() } : null),
});

const handler = async (res) => {
  if (!res.ok) {
    throw (await res.json());
  } else { return res.json(); }
};

const get = (endpoint, header = null) => fetch(api + endpoint, {
  method: 'get',
  headers: headerBuilder(header),
}).then(handler);

const post = (endpoint, form = null, header = null) => fetch(api + endpoint, {
  method: 'post',
  body: JSON.stringify(form),
  headers: headerBuilder(header, form),
}).then(handler);

const put = (endpoint, form = null, header = null) => fetch(api + endpoint, {
  method: 'put',
  body: JSON.stringify(form),
  headers: headerBuilder(header, form),
}).then(handler);

const del = (endpoint, form = null, header = null) => fetch(api + endpoint, {
  method: 'delete',
  body: JSON.stringify(form),
  headers: headerBuilder(header, form),
}).then(handler);

export {
  get, post, del, put,
  setToken, getToken,
};
